import {sendMessageToExtension} from './base/sendExternal';

export const getExtensionVersion = () =>
  sendMessageToExtension<void, string>('getExtensionVersion', undefined);

export const getIsExtensionAuthenticated = () =>
  sendMessageToExtension<void, boolean>('isExtensionAuthenticated', undefined);

export const isBlueAuthenticated = () =>
  sendMessageToExtension<void, boolean>('isBlueAuthenticated', undefined);

export const getUserBlueUrl = () => {
  const liFeed = 'https://linkedin.com/feed/';
  const extraWindow = window.open(liFeed, '_blank');
  extraWindow?.close();
  return sendMessageToExtension<void, string>('getUserBlueUrl', undefined);
};

export const passSessionDump = async (dump: Record<string, unknown>) =>
  sendMessageToExtension<Record<string, unknown>, boolean>('passSessionDump', dump);

export const getSessionDump = async () => {
  const dump = await sendMessageToExtension<void, string>('getSessionDump', undefined);
  if (!dump) {
    return null;
  }
  try {
    return JSON.parse(dump) as Record<string, unknown>;
  } catch (e) {
    console.error('Error parsing session dump:', e);
    return null;
  }
};

export const logout = () => sendMessageToExtension<void, void>('logout', undefined);
